module.exports = __webpack_public_path__ + "static/media/024-Cafe Quatre Jeudis.85f6081a.jpg";